import { inject, Injectable, signal } from '@angular/core';
import { SLOTS_DAY_MAP, WeekdayIndex } from '@eforall/common';
import { SelectedSlotsWithCount } from '@interfaces';
import { FuncService } from '../../../services';

@Injectable({ providedIn: 'root' })
export class ScheduleService {

	private readonly func = inject(FuncService);

	private readonly _updatedSelectedSlots = signal<SelectedSlotsWithCount | undefined>(undefined);
	private readonly _isEditMode = signal<boolean>(false);

	public readonly updatedSelectedSlots = this._updatedSelectedSlots.asReadonly();
	public readonly isEditMode = this._isEditMode.asReadonly();


	setIsEditMode(isEditMode: boolean) {
		this._isEditMode.set(isEditMode);
	}

	setUpdatedSelectedSlots(slots: SelectedSlotsWithCount) {
		this._updatedSelectedSlots.set(slots);
	}

	setUpdatedSelectedSlotsForDay(count: number, dayIndex: WeekdayIndex, selectedSlotString: string) {
		const dayKey = SLOTS_DAY_MAP[dayIndex];
		const selectedSlot = { [dayKey]: selectedSlotString };

		this._updatedSelectedSlots.update(current => current ? { ...current, ...selectedSlot, numMeetings: count } : current);
	}

	async updateMeetings(meetingsId: number, selectedSlotsWithCount: SelectedSlotsWithCount) {
		await this.func.meetings.updateMeetings({ meetingsId, selectedSlotsWithCount });
		this.setIsEditMode(false);
	}

}